module.exports = __webpack_public_path__ + "img/budget.7af660c0.svg";